module.exports = __webpack_public_path__ + "img/mira-matyi.087b4cf9.jpg";